/* eslint-disable sort-keys-custom-order-fix/sort-keys-custom-order-fix */
import { webChatTranslations } from '@speeki/chat-web-components';
import {
    caseStatusesIterable,
    COUNTRY_CODE_ORDERED,
    USER_RELATIONSHIP,
} from '@speeki/dictionary';

export const defaultTranslations = {
    ...webChatTranslations,
    AGREE: 'Agree',
    ALREADY_HAVE_AN_ACCOUNT_TEXT: 'Already have an account?',
    ALREADY_HAVE_AN_ACCOUNT: 'I already have an account',
    ATTACHMENT: 'Attachment',
    BEFORE_GETTING_STARTED_INFO_1:
        'This service is not an emergency hotline or a substitute for contacting law enforcement',
    BEFORE_GETTING_STARTED_INFO_2:
        'The information submitted via this service may not be reviewed immediately',
    BEFORE_GETTING_STARTED_INFO_3:
        'If you are facing a life-threatening emergency or believe you are facing the threat of imminent bodily harm, please contact your local police or emergency service immediately',
    BEFORE_GETTING_STARTED_INFO_4:
        'Use of this app signifies your agreement to our',
    BEFORE_GETTING_STARTED_INFO_TEXT: 'You understand and acknowledge that',
    BEFORE_GETTING_STARTED_TEXT: 'Before getting started',
    CANCEL: 'Cancel',
    CASE_NOT_FOUND: 'Incident not found',
    CG_CARD_1: 'Guest account',
    CG_CARD_2: 'Guest account does not receive notification automatically.',
    CG_CARD_3:
        'Guest account requires to log in from time to time to retrieve report update.',
    CG_CARD_4: 'Have you changed your mind and want to sign up?',
    CHANGE_COMPANY_CODE_ERROR: 'Failed to change company code',
    CHANGE_COMPANY_CODE_INFO:
        'By changing the code you will be logged in to the account of the company whose code you provide.',
    CHANGE_COMPANY_CODE_SUCCESS:
        'You’ve switched over to the new company successfully.',
    CHANGE_COMPANY_TEXT: 'Change company',
    CHANGE_COUNTRY: 'Change country',
    CHANGE_COUNTRY_ERROR: 'Failed to change country',
    CHANGE_COUNTRY_SUCCESS: 'Country has been successfully changed.',
    CHANGE_EMAIL_ADDRESS: 'Change email address',
    CHANGE_EMAIL_ERROR: 'Failed to change email',
    CHANGE_EMAIL_INFO:
        'The email address you provided here is for password recovery. It will not be shared with anyone and used for other purpose.',
    CHANGE_EMAIL_SUCCESS: 'Your email address has been successfully changed',
    CHANGE_LANGUAGE: 'Change language',
    CHANGE_LANGUAGE_ERROR: 'Failed to change language',
    CHANGE_LANGUAGE_INFO:
        'Reports and chat messages entered in languages other than English may be translated by Google, which is located in the European Economic Area.',
    CHANGE_LANGUAGE_SUCCESS: 'Language has been successfully changed.',
    CHANGE_PASSWORD: 'Change password',
    CHANGE_PASSWORD_ERROR: 'Failed to change password',
    CHANGE_PASSWORD_SUCCESS: 'Your password has been successfully changed.',
    CHANGE_PERSONAL_INFO_SUCCESS:
        'Personal information has been successfully changed.',
    CHANGE_RELATIONSHIP: 'Change relationship',
    CHANGE_RELATIONSHIP_ERROR: 'Failed to change company relationship',
    CHANGE_RELATIONSHIP_SUCCESS: 'Relationship has been successfully changed.',
    CHANGE_TO_EMAIL: 'Change to email address',
    CHANGE_TO_PHONE: 'Change to phone',
    CHAT: 'Chat with Manager',
    CHAT_NEW_FILE_MESSAGE: 'You have unread file(s)',
    CHAT_NO_MESSAGES: 'You have no new message',
    CHAT_YOUR_MESSAGE: 'Your message...',
    CHECK_STATUS: 'Check status',
    CHECK_STATUS_CARD:
        'If you have an account, log in with your email address or ID.',
    CHECK_STATUS_INFO:
        'You can check your report status by providing your Report ID and Report PIN. Without a Report ID and/or PIN, you cannot check your report status.',
    CHECK_STATUS_LOGIN_ERROR: 'Failed to login',
    CHECK_STATUS_LOGIN_SUCCESS: "You've successfully logged in.",
    CLICK_HERE: 'Click here.',
    COMPANY: 'Company',
    COMPANY_CODE: 'Company code',
    COMPANY_CODE_PLACEHOLDER: 'Enter company code',
    COMPANY_CODE_TOO_LONG: 'Company code is too long, maximum 10 characters',
    COMPANY_CODE_TOO_SHORT: 'Company code is too short, minimum 3 characters',
    COMPANY_HEADER_POSTFIX: 'compliance solution of choice',
    COMPANY_HEADER_SUBPOSTFIX:
        'On the right side you will find a list of following services available for you.',
    COMPANY_INFORMATION_TEXT: 'Company information',
    COMPANY_NAME: 'Company name',
    COMPANY_NAME_PLACEHOLDER: 'Enter your company name',
    COMPANY_PAGE_WELCOME_FOLLOWING_SERVICES:
        'The following services are available to you:',
    COMPANY_WELCOME_SUBTEXT:
        'Speeki is a compliance platform that helps you speak up and make sure your voice is heard. The Speeki platform includes compliance reporting, whistleblowing and other services that are crafted to help your company gather your honest feedback to ensure compliance and drive effective growth.',
    COMPANY_WELCOME_TEXT: 'Welcome to Speeki',
    CONFIRM_EMAIL: 'Confirm email',
    CONFIRM_EMAIL_PLACEHOLDER: 'Re-enter your email address',
    CONFIRM_NEW_PASSWORD: 'Confirm new password',
    CONFIRM_NEW_PASSWORD_PLACEHOLDER: 'Re-enter new password',
    CONFIRM_PASSWORD: 'Confirm password',
    CONFIRM_PASSWORD_PLACEHOLDER: 'Re-enter password',
    CONTINUE: 'CONTINUE',
    CONTINUE_AS_A_GUEST: 'Continue as a guest',
    CONTINUE_TO_SUBMIT: 'Continue to submit',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select a country',
    CREATE_NEW_REPORT: 'Create new report',
    CREATE_NEW_REPORT_TEXT: 'create a new report',
    CURRENT_PASSWORD: 'Current password',
    CURRENT_PASSWORD_PLACEHOLDER: 'Enter current password',
    DATE: 'Date',
    LAST_MESSAGE_DATE: 'Last message date',
    SUBMISSION_PREVIEW: 'Submission preview',
    NO_MESSAGES_YET: 'There are no messages yet',
    DECLARE_WHO_YOU_ARE_DESCRIPTION:
        'We require this information for further necessary communications on reviewing your report. Please be aware that this information will be sent along with your report. It will be used only for your Collect forms, and won’t be shared or used for other services such as anonymous Speeki Incidents or Speeki Pulse.',
    DECLARE_WHO_YOU_ARE_TEXT: 'Declare who you are',
    DISCLOSURE_ANSWER_HEADER_MESSAGE: 'Message',
    DISCLOSURE_ANSWER_HEADER_SUBMISSION: 'Submission date',
    DISCLOSURE_GUEST_INFO_DESCRIPTION:
        'To filling out Collect forms, you need to be a logged in user. Please sign up or, if you already have an account, log in.',
    DISCLOSURE_GUEST_INFO_TITLE: 'Guest user information',
    DISCLOSURE_LIST_HEADER_NAME: 'Collect form',
    DISCLOSURE_TEXT: 'Collect',
    DISCLOSURE_THANK_YOU_DESCRIPTION: 'We appreciate you filling out the form.',
    DISCLOSURE_UNAVAILABLE_DESCRIPTION:
        'It seems that the Collect form that you are looking for is no longer available. But no worries we have other for you to fill out.',
    DONT_HAVE_ACCOUNT: 'Don’t have an account?',
    DONT_KNOW_COMPANY_CODE: 'Don’t know your company code?',
    DOWNLOAD_CASE_CONTENT_SUBTITLE_1:
        'To continue, please enter the Incident PIN.',
    DOWNLOAD_CASE_CONTENT_SUBTITLE_2:
        'To start downloading the incident content please click on a button below.',
    DOWNLOAD_CASE_CONTENT_TITLE: 'Download incident content to PDF',
    DOWNLOAD_PDF: 'download pdf',
    EMAIL: 'Email address',
    EMAIL_ALREADY_TAKEN: 'Provided email address is already taken',
    EMAIL_MATCH: "The given email doesn't match",
    EMAIL_NOT_FOUND: 'Provided email address was not found',
    EMAIL_NOT_VALID: 'Email not valid',
    EMAIL_OR_ID: 'Email address or ID',
    EMAIL_OR_ID_PLACEHOLDER: 'Enter email address or ID',
    EMAIL_PLACEHOLDER: 'Enter your email',
    EMAIL_PLACEHOLDER_OPTIONAL: 'Enter your email (optional)',
    EMAIL_TEXT: 'Email',
    EMAIL_TOO_LONG: 'Email is too long, maximum 75 characters',
    EMPTY_CASE_TILE: 'Is there something you want to speak up about?',
    EMPTY_REPORT_LIST_DESCRIPTION:
        'You do not have a report yet. Do you wish share a concern with your company?',
    EMPTY_RESULT: 'Empty result',
    FIELD_CANNOT_BE_EMPTY: 'This field cannot be empty',
    FIELD_ENTITY_NAME_NOT_EXISTS:
        "The entity name doesn't exist. Please specify an existing entity name",
    FIELD_MUST_BE_CHECKED: 'Field must be checked',
    FILES_UPLOAD_ERROR: 'Failed to upload files',
    FILE_DELETE_ERROR: 'Failed to delete file',
    FILE_PASSWORD_INFO: 'The file is password protected for data security.',
    FILE_PASSWORD_TEXT: 'The file password',
    FILE_SIZE_ERROR: 'File size is too large',
    FILE_UPLOAD_ERROR: 'Failed to upload file',
    FIRST_EMAIL_LOGIN_DESCRIPTION:
        'We are migrating your user profile to the new system. You will be using your email address to login to Speeki application. For your information, the email address is used only to log in and it is not visible to anyone except you.',
    FIRST_EMAIL_LOGIN_TEXT: 'Email request',
    FIRST_NAME: 'First name',
    FIRST_NAME_PLACEHOLDER: 'Enter your first name',
    FIRST_NAME_TOO_LONG: 'Name is too long, maximum 50 characters',
    FORBIDDEN: 'Forbidden',
    FORGOT_PASSWORD: 'Forgot password?',
    FORGOT_PASSWORD_ERROR: 'Failed to reset password',
    FORGOT_PASSWORD_INFO:
        "If the email you specified exists in our system, we've sent a password reset link to it",
    FORMS_TEXT: 'available',
    GET_COUNTRIES_ERROR: 'Failed to fetch countries',
    GET_FILE_URL_ERROR: 'Failed to fetch file url',
    GET_HOME_INFO_ERROR: 'Failed to get home content',
    GET_HOME_REPORTS_ERROR: 'Failed to fetch home reports',
    GET_LANGUAGE_ERROR: 'Failed to fetch language',
    GET_RELATIONSHIP_ERROR: 'Failed to fetch relationship',
    GET_REPORTS_ERROR: 'Failed to fetch reports',
    GET_REPORT_SUMMARY_ERROR:
        'Error occurred while try to access this incident.',
    GET_SETTINGS_ERROR: 'Failed to fetch settings',
    GET_TRANSLATE_ERROR: 'Failed to fetch translation',
    GET_USER_INFO_ERROR: 'Failed to fetch User data',
    GO_BACK: 'Go back',
    GO_TO_DASHBOARD: 'Go to dashboard',
    GO_TO_HOMEPAGE: 'Go to homepage',
    GO_TO_MY_FORMS: 'Go to my forms',
    GUEST_CONTINUE: 'Continue as guest',
    GUEST_MODE_FORM_INFO_TEXT:
        'To continue in guest mode define your relationship to the company and select the country. This will allow the content displayed to be relevant to you.',
    GUEST_MODE_TEXT: 'Guest mode',
    GUEST_USER: 'Guest user',
    HELP: 'Help',
    HIDE_PIN: 'Hide PIN',
    HOME_GUEST_INFO:
        'If you reported as a guest, you can check your report status here. Log in with Report ID and Report PIN. If you lose your Report ID number and/or Report PIN, you will not receive feedback.',
    HOW_DO_YOU_WANT_TO_BE_CONTACTED: 'How do you want to be contacted?',
    INVALID_EMAIL:
        'Email address format is invalid. Please enter for e.g. joedoe@mail.com',
    INVALID_PIN: 'PIN must consist of exactly 6 characters',
    JWT_SESSION_EXPIRED:
        'Your session has expired. Please sign out and sign in again.',
    LANGUAGE: 'Language',
    LANGUAGE_PLACEHOLDER: 'Select language',
    LAST_NAME: 'Last name',
    LAST_NAME_PLACEHOLDER: 'Enter your last name',
    LAST_NAME_TOO_LONG: 'Last name is too long, maximum 50 characters',
    LEAVE: 'Leave',
    LEAVE_INFO:
        'It looks like you are in the middle of reporting. If you leave now you won’t be able to continue this report.',
    LEAVE_TITLE: 'Are you sure you want to leave?',
    LESS: 'Less',
    LOAD_MORE: 'Load more',
    LOGGED_IN_TO_TEXT: 'Logged in to',
    LOGIN: 'Log in',
    LOGIN_ALREADY_TAKEN: 'Login already taken',
    LOGIN_ERROR: 'Failed to login',
    LOGIN_HINT_SUBTITLE_1_1:
        'If you do not have any account yet, you may proceed to',
    LOGIN_HINT_SUBTITLE_1_2: 'to create it.',
    LOGIN_HINT_SUBTITLE_2:
        "If you have an Incident ID and Incident PIN, please click 'Continue as guest' and then you can enter your Incident ID and PIN after the guest login.",
    LOGIN_HINT_TITLE_1:
        'Your login credential is incorrect. This login for is meant for user who has previously registered an account.',
    LOGIN_SUCCESS: "You've successfully logged in.",
    LOGOUT: 'Log out',
    MARK_ALL_AS_READ_TEXT: 'Mark all as read',
    MAX_LENGTH_CHAT_FILES: 'You can upload up to 10 files at a time.',
    MESSAGE: 'Message',
    MESSAGE_TOO_LONG: 'Message is too long, maximum 500 characters',
    MESSAGING_TEXT: 'Incidents',
    MORE: 'More',
    MY_CASES_TEXT: 'My incidents',
    MY_FORMS_TEXT: 'My forms',
    MY_POLICIES_TEXT: 'Company policies',
    MY_REPORTS: 'My reports',
    MY_SURVEYS_TEXT: 'My pulses',
    NEW_EMAIL: 'New email address',
    NEW_EMAIL_PLACEHOLDER: 'Enter your new email',
    NEW_PASSWORD: 'New password',
    NEW_PASSWORD_PLACEHOLDER: 'Enter new password',
    NICOLE: 'Nicole',
    NICOLE_GOOD_TO_SEE_YOU: 'good to see you again!',
    NICOLE_HELLO: 'Hello,',
    NICOLE_INFO:
        'Here are some questions that will help you to report to your company. This is completely anonymous and your personal information will not be shown in the report.',
    NICOLE_I_M: 'I’m Nicole',
    NOTHINGS_HERE_TEXT: 'There are no reports yet',
    NOTIFICATIONS: 'Notifications',
    NO_ACTIVE_DISCLOSURES: 'There are no active collect forms',
    NO_ACTIVE_DISCLOSURES_INFO:
        "Don't worry, collect forms are created by us periodically so try again later. Thank you for your involvement.",
    NO_ACTIVE_SURVEYS: 'There are no active pulses',
    NO_ACTIVE_SURVEYS_INFO:
        "Don't worry, pulses are created by us periodically so try again later. Thank you for your involvement.",
    NO_NOTIFICATIONS_TEXT: 'There are no notifications',
    NO_REPORTS: 'No data found. Please change the criteria.',
    NO_RESULTS: 'Sorry, no results found',
    NO_RESULTS_DESCRIPTION:
        'Make sure you have typed the search name correctly or change the query.',
    ONGOING: 'ongoing',
    OR: 'or',
    PAGE_NOT_FOUND: 'Page not found',
    PAGE_NOT_FOUND_INFO:
        'The link you clicked may be broken or the page may have been removed or renamed',
    PASSWORD: 'Password',
    PASSWORD_CONFIRMATION_REQUIRED: 'Password confirmation is required',
    PASSWORD_INFO: 'Your password needs to contain at least 8 characters.',
    PASSWORD_MATCH: 'Password need to match',
    PASSWORD_PLACEHOLDER: 'Enter password',
    PASSWORD_REQUIRED: 'Password is required',
    PASSWORD_TOO_LONG: 'Password is too long, maximum 100 characters',
    PASSWORD_TOO_SHORT: 'Password is too short, minimum 8 characters',
    PHONE_MOBILE_TEXT: 'Phone/Mobile',
    PHONE_NUMBER: 'Phone number',
    PHONE_NUMBER_IS_INVALID: 'Phone number is invalid',
    PHONE_NUMBER_IS_TOO_LONG: 'Phone number is too long, maximum 15 characters',
    PHONE_NUMBER_IS_TOO_SHORT:
        'Phone number is too short, minimum 3 characters',
    PHONE_NUMBER_PLACEHOLDER: 'Enter your phone number',
    PLEASE_WAIT: 'Please wait',
    PRIVACY_POLICY: 'Privacy Policy',
    PROFILE_SETTING: 'We are in the middle of setting your profile',
    RELATIONSHIP: 'Relationship',
    RELATIONSHIP_TO_COMPANY: 'Relationship to company',
    RELATIONSHIP_TO_COMPANY_PLACEHOLDER: 'Select relationship',
    REPORTS_EMPTY: 'You haven’t created any reports yet.',
    REPORT_CHECK_AND_EDIT: 'Check and edit conversation',
    REPORT_EDIT_ERROR: 'Failed to edit report transcription',
    REPORT_EDIT_INFO_PART_1:
        'You can make changes to the transcript of your report if needed.',
    REPORT_EDIT_INFO_PART_2: 'Changes can only be made once.',
    REPORT_EDIT_MESSAGE_ERROR: 'Failed to edit message',
    REPORT_EDIT_SUCCESS: 'Report transcription has been successfully changed.',
    REPORT_EDIT_TEXT: 'Report edition',
    REPORT_EVIDENCE: 'If you have any evidence files, attach them below.',
    REPORT_EVIDENCE_UPLOAD: 'Upload proof / evidence files',
    REPORT_EVIDENCE_UPLOAD_SIZE:
        'Each file up to 50MB, maximum 200MB per request.',
    REPORT_GET_SUMMARY_ERROR: 'Failed to fetch report summary',
    REPORT_ID: 'Report ID',
    REPORT_ID_PLACEHOLDER: 'Enter Report ID',
    REPORT_PIN: 'Report PIN',
    REPORT_PIN_PLACEHOLDER: 'Enter Report PIN',
    REPORT_PIN_SET: 'Set Report PIN',
    REPORT_SAVE_ERROR: 'Failed to save report',
    REPORT_SEND_ERROR: 'Failed to submit report',
    REPORT_START_ERROR: 'Failed to create report',
    REPORT_SUBMITTED_INFO:
        'Your company will follow up your report as soon as possible. You can check the report status to observe progress. Or you can send an anonymous message to your company for the progress. Please save Incident ID number.',
    REPORT_SUBMITTED_TITLE: 'Your report has been submitted ',
    REPORT_UPLOAD_FILES: 'Upload files',
    REPORT_YOUR: 'Your report',
    REPORT_YOUR_ID: 'Your Report ID',
    REQUIRED: 'Required',
    RESET_PASSWORD: 'Reset password',
    RESET_PASSWORD_ERROR: 'Failed to reset password',
    RESET_PASSWORD_SUCCESS: 'Your password has been reset successfully.',
    SAVE: 'Save',
    SEARCH: 'Search',
    SEARCH_PLACEHOLDER: 'Search...',
    SEE_MORE: 'See more',
    SEND: 'SEND',
    SETTINGS: 'Settings',
    SETTINGS_CHANGE_COMPANY_TEXT:
        'If you want to change company you need to log out and log in again using the email address and password associated with the other company.',
    SETTINGS_CHANGE_COUNTRY_TEXT: 'Select the relevant country from the list.',
    SETTINGS_CHANGE_EMAIL_TEXT: 'Your current email address: ',
    SETTINGS_CHANGE_LANGUAGE_TEXT:
        'If you want to change language, select the one below.',
    SETTINGS_CHANGE_PASSWORD_TEXT:
        'Your new password needs to contain at least 8 characters. You can use a-z, 0-9 and any special characters.',
    SETTINGS_CHANGE_RELATIONSHIP_TEXT:
        'Select your relationship to the company from the list. ',
    SETTINGS_OPTION_1: 'Country',
    SETTINGS_OPTION_2: 'Relationship to company',
    SETTINGS_OPTION_3: 'Company code',
    SHOW_PIN: 'Show PIN',
    SIGN_UP: 'Sign up',
    SIGN_UP_EMAIL_INFO:
        'This email address is for the purpose of receiving updates and is not shared with anyone.',
    SIGN_UP_ERROR: 'Failed to signup',
    SIGN_UP_SUCCESS: "You've successfully signed in.",
    SIGN_UP_TOOLTIP_TEXT:
        "We only use your email address to attach your records to your profile and send you updates regarding those records. We won't share it with the entity for which you are accessing the platform.",
    SOMETHING_WENT_WRONG: 'Something went wrong',
    SOMETHING_WENT_WRONG_BUTTON: 'Refresh page',
    SOMETHING_WENT_WRONG_INFO: 'Refresh this page or try again later',
    START: 'Start',
    START_CARD_1:
        'Protect your identity and feel secure with an anonymous account',
    START_CARD_2:
        'Communicate with convenience and security through our private channels',
    START_CARD_3:
        'Ensure anonymity with workflows that route your reports to appropriate and only need-to-know authorities',
    START_CARD_4:
        'Manage interactions with real-time notifications and updates on your reports',
    START_CARD_5:
        'Engage in organisation-wide pulses that lets your voice be heard',
    START_CARD_6: 'A 360° communication tool that guarantees anonymity.',
    START_INFO:
        'Don’t put up with misconduct happening in your organization or when you do business. Do the right thing. With Speeki, you can choose to report with complete anonymity.',
    START_TITLE: 'If you witness any misconduct, report it immediately',
    STATUS: 'Status',
    SUBMIT_REPORT: 'Submit report',
    SURVEY_BACK_TO_LIST_BUTTON: 'Go back to pulse list',
    SURVEY_FILLED_DESCRIPTION:
        'You have already completed this pulse. Thank you for participating!',
    SURVEY_LIST_HEADER_DATE: 'End date',
    SURVEY_LIST_HEADER_NAME: 'Pulse name',
    SURVEY_TEXT: 'Pulse',
    SURVEY_THANK_YOU_DESCRIPTION:
        'We appreciate that you took your time to fill out this pulse. Thanks to you we will be able to deal with this problem in a better way.',
    SURVEY_UNAVAILABLE_DESCRIPTION:
        'It seems that the pulse that you are looking for is either not yet valid or already expired. Please explore other pulses or reach out to your administrator if you suspect an error.',
    TERMS: 'You understand and acknowledge that: This service is not an emergency hotline or a substitute for contacting law enforcement. The information submitted via this service may not be, reviewed immediately. If you are facing a life-threatening emergency or believe you are facing the threat of imminent bodily harm, please contact your local police or emergency service immediately. Use of this portal signifies your agreement to our Privacy Policy.',
    THANK_YOU_TITLE: 'Thank you for your participation!',
    THIS_CONSENT_IS_MANDATORY: 'This consent is mandatory',
    TILE_ACTIVE: 'active',
    TILE_ONGOING: 'ongoing reports',
    TILE_UNREAD: 'unread messages',
    TILE_YOU_HAVE: 'You have',
    TOO_BIG_CHAT_FILE: 'File is too big. Maximum file size is 20MB',
    TOO_MANY_FILES: 'Too many files',
    TRANSCRIPTION: 'Transcription',
    TRY_APP: 'Try the app',
    UNAVAILABLE_TITLE: 'Oops...',
    UNKNOWN: 'Unknown',
    UPDATE_RECEIVE: 'Receive update',
    UPLOADED_FILES: 'Uploaded files',
    UPLOADED_FILES_EMPTY: 'There are no files added',
    USER: 'User',
    USER_NAME_TOO_LONG: 'User name is too long, maximum 75 characters',
    VALIDATION_ERROR: 'Validation error',
    WELCOME: 'Welcome!',
    WELCOME_DESCRIPTION: 'Please enter the company name to start.',
    WRITE_YOUR_ANSWER: 'Write your answer',
    WRONG_CHAT_FILE_TYPE: 'Provided file(s) type is not supported',
    WRONG_COMPANY_CODE: 'Provided company code is invalid',
    WRONG_FILE_TYPE: 'Provided file(s) type is not supported',
    WRONG_USER_OR_PASSWORD: 'Wrong user or password',
    NEXT: 'next',
    CONFIRM: 'confirm',
    SEND_REQUEST: 'send request',
    LOG_IN_SECURELY: 'log in securely',
    REMEMBER_DEVICE: 'Remember me on this device',
    REMEMBER_BROWSER: 'Remember me on this browser',
    ENTER_VERIFICATION_CODE: 'Enter verification code',
    SETUP_MFA_HEADER_FIRST_LINE: 'Secure your data',
    SETUP_MFA_HEADER_SECOND_LINE: 'with multi-factor authentication',
    SETUP_MFA_FIRST_STEP_TITLE: 'Step 1. Get a mobile authenticator',
    SETUP_MFA_FIRST_STEP_TEXT: `Install any authenticator app you want (e.g. Google Authenticator, Microsoft Authenticator, Authy) on your phone. When you have it installed, continue to Step 2.`,
    SETUP_MFA_SECOND_STEP_TITLE_ON_MOBILE: 'Step 2. Copy the secret key',
    SETUP_MFA_SECOND_STEP_TEXT_ON_MOBILE:
        'Copy the secret key and paste it in your authenticator app.',
    SETUP_MFA_SECOND_STEP_TITLE_MANUAL: 'Step 2. Enter the secret key',
    SETUP_MFA_SECOND_STEP_TEXT_MANUAL:
        'Manually enter the secret key into your authenticator app.',
    SETUP_MFA_SECOND_STEP_TITLE_QR: 'Step 2. Scan the QR code',
    SETUP_MFA_SECOND_STEP_TEXT_QR:
        'Use your authenticator app to scan this QR code.',
    SETUP_MFA_THIRD_STEP_TITLE: 'Step 3. Test your multi-factor authentication',
    SETUP_MFA_THIRD_STEP_TEXT:
        'Enter the 6-digit code generated by your authentication app.',
    SETUP_MFA_FOURTH_STEP_TITLE: 'Step 4. Set up your recovery email',
    SETUP_MFA_FOURTH_STEP_TEXT: `If you lose your authenticator app or device, you'll need to use the second email address to reset your multi-factor access. We'll use this email only for the recovery, and we won't share it with anyone else.`,
    SETUP_MFA_REQUEST_ERROR: `Oops! There was an issue while setting up Multi-Factor Authentication. Please try again later or contact support.`,
    SCAN_QR_CODE_INSTEAD: 'Scan the QR code instead',
    CANT_SCAN_QR_CODE: 'Can’t scan the QR code?',
    TOO_SHORT_CODE: 'Code must consist of exactly 6 characters',
    EMAIL_NOT_MATCH: 'The given email addresses do not match.',
    MFA_POINTS_FRAME_HEADER:
        'Your organisation has started using multi-factor authentication in order to keep your data secure.',
    MFA_POINTS_FRAME_FIRST_POINT:
        'Multi-factor authentication helps protect your account from unauthorised access',
    MFA_POINTS_FRAME_SECOND_POINT:
        'To set up multi-factor authentication for your account, please follow the on-screen steps',
    MFA_POINTS_FRAME_THIRD_POINT:
        'If you would like to set up MFA later, you can skip this step for now using the button under the ‘Next’ one.',
    ENTER_SECONDARY_EMAIL: 'Enter your secondary email',
    CONFIRM_SECONDARY_EMAIL: 'Confirm secondary email address',
    RE_ENTER_SECONDARY_EMAIL: 'Re-enter your secondary email',
    MFA_TROUBLES: `If you're having trouble using the multi-factor authentication (MFA) app or you have lost your MFA device, click the button below to reset and set up a new authentication.`,
    ENTER_6_DIGIT_CODE: `Please enter the 6-digit code for Speeki in your authentication app to confirm your identity`,

    // KOTLIN REFACTOR - AUTH
    FORGOT_PASSWORD_FORM_SUBTITLE:
        'Set up a new password to your Speeki account.',
    CASE_MANAGER: 'Incident Manager',
    FORGOT_PASSWORD_CONFIRMATION_TITLE: 'Email has been sent to ',
    FORGOT_PASSWORD_CONFIRMATION_SUBTITLE_1:
        'Please check your inbox and follow the instructions on the email to activate your account.',
    FORGOT_PASSWORD_CONFIRMATION_SUBTITLE_2:
        'Did you not receive an email? Check the junk mail folder or try again.',
    FORGOT_PASSWORD_RESET_PASSWORD: 'Change password',
    FORGOT_PASSWORD_NEW_PASSWORD: 'New password',
    FORGOT_PASSWORD_NEW_PASSWORD_PLACEHOLDER: 'Enter new password',
    FORGOT_PASSWORD_CONFIRM_NEW_PASSWORD: 'Confirm new password',
    FORGOT_PASSWORD_CONFIRM_NEW_PASSWORD_PLACEHOLDER: 'Re-enter new password',
    PASSWORD_RESET_TO_SHORT: 'Password is too short, minimum 8 characters',
    PASSWORD_RESET_TO_LONG: 'Password is too long, maximum 14 characters',
    PASSWORD_RESET_CONFIRM_DO_NOT_MATCH: 'Given passwords are not the same',
    SEND_NEW_PASSWORD: 'save and continue to log in',
    SEND_NEW_PASSWORD_WITHOUT_MFA: 'Save and log in',
    AVAILABLE_MICROSERVICES: 'Services available for you:',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    ERROR_RESET_LINK_EXPIRED: 'Password reset link has expired.',

    // KOTLIN REFACTOR - CASES
    NEW: 'New',
    OPEN: 'Open',
    ACTIVATED: 'Activated',
    CLOSED: 'Closed',
    REOPEN: 'Reopen',
    INACTIVE: 'Inactive',
    NEW_CONVERSATION_TEXT_1:
        'Here are some questions that will help you to report to your company.',
    NEW_CONVERSATION_TEXT_2:
        'Depending on the country in which the incident occurred and the type of incident, reports are anonymous or require contact information.',
    START_CONVERSATION: 'Start conversation',
    NEW_CONVERSATION_DETAILS_TITLE: 'New conversation details',
    NEW_CONVERSATION_DETAILS_INFO:
        'To start new conversation please provide some information.',
    COUNTRY_INCIDENT: 'Country where the incident occurred',
    INCIDENT_TYPE: 'Incident type',
    SELECT_COUNTRY: 'Select country',
    SELECT_INCIDENT_TYPE: 'Select incident type',
    SELECT_CASE_OWNER: 'Select incident manager',
    EXCLUDE_INFO:
        'You may choose to exclude an incident manager from reviewing your report.',
    EXCLUDE_CASE_OWNER: 'Exclude the following incident manager',
    NEW_CONVERSATION_PERSONAL_INFO_TEXT:
        'You can report anonymously or provide us with your contact information so we can reach out to you when needed.',
    NEW_CONVERSATION_PERSONAL_INFO_BUTTON:
        "Yes, I'd like to provide my contact details",
    NEW_CONVERSATION_PERSONAL_INFO_BUTTON_NO:
        "No, I don't want to provide my contact details",
    NAME: 'Name',
    ENTER_NAME: 'Enter your name',
    ENTER_LAST_NAME: 'Enter your last name',
    EMAIL_ADDITIONAL:
        'You are required to provide your corporate email address.',
    NEW_CONVERSATION_MANDATORY_PERSONAL_INFO_TEXT: 'In',
    NEW_CONVERSATION_MANDATORY_PERSONAL_INFO_TEXT_1: 'this',
    NEW_CONVERSATION_MANDATORY_PERSONAL_INFO_TEXT_2:
        'incident type may not be reported anonymously.',
    NEW_CONVERSATION_MANDATORY_PERSONAL_INFO_TEXT_3:
        'Please provide your contact details.',
    NEW_CONVERSATION_PIN: 'PIN must be exactly 6 characters',
    REPORT_PIN_INFO:
        'Please create a six-digit PIN. It will be necessary to retrieve the same report in the future.',
    UPDATE_EMAIL_INFO_1:
        'Provide an email to receive a copy of the submitted Report, PIN, Report ID and Report updates.',
    UPDATE_EMAIL_INFO_2:
        'We do not share your email address with the company you are reporting to. This email address you provided is for only one purpose where to send you report information and when the incident has an update.',
    EMAIL_OPTIONAL: 'Please provide a valid email address.',
    ORGANISATION_GENERIC: 'your organisation',
    ORGANISATION_NAMED: '{{tenantName}} (your organisation)',
    REPORTER_IDENTITY_EMAIL_LABEL: 'Your email address',
    REPORTER_IDENTITY_EMAIL_LABEL_OPTIONAL: 'Your email address (optional)',
    REPORTER_IDENTITY_EMAIL_DISCLOSURE:
        "If you provide it, {{organisation}} will see it as your contact details. Leave it blank if you'd rather not share it.",
    REPORTER_UPDATES_EMAIL_LABEL_OPTIONAL: 'Email for updates (optional)',
    REPORTER_UPDATES_EMAIL_PRIVACY:
        "Private — your organisation never sees this address. An address we can't confirm won't be used.",
    REPORTER_UPDATES_EMAIL_CONFIRMED_HELPER:
        "We'll send updates here. Your organisation never sees this address.",
    REPORTER_SAME_EMAIL_WARNING:
        'You already shared this address with {{organisation}} earlier in this report. If you want your updates address to stay private, use a different one.',
    REPORTER_EMAIL_SEND_CODE: 'Send code',
    REPORTER_EMAIL_CONFIRMED_BADGE: 'Confirmed',
    REPORTER_EMAIL_CONFIRM_SENT:
        "We've sent a 6-digit code to that address. It can take a minute — check your spam folder too.",
    REPORTER_EMAIL_CONFIRM_CHANGE_ADDRESS: 'Change',
    REPORTER_EMAIL_CONFIRM_CODE_LABEL: 'Enter code',
    REPORTER_EMAIL_CONFIRM_CODE_GROUP_LABEL: '6-digit confirmation code',
    REPORTER_EMAIL_CONFIRM_CODE_DIGIT_LABEL: 'digit {{index}} of {{total}}',
    REPORTER_EMAIL_CONFIRM_RESEND_WAIT: 'Resend in {{seconds}}s',
    REPORTER_EMAIL_CONFIRM_RESEND_NOW: 'Resend',
    REPORTER_EMAIL_CONFIRM_REMOVE_PREFIX: 'Or ',
    REPORTER_EMAIL_CONFIRM_REMOVE_ACTION: 'remove the address',
    REPORTER_EMAIL_CONFIRM_REMOVE_SUFFIX:
        " and continue without it — you'll still get your report reference.",
    REPORTER_EMAIL_CONFIRM_WRONG_CODE_ONE:
        "That code isn't right. You have 1 more try before you'll need a new code.",
    REPORTER_EMAIL_CONFIRM_WRONG_CODE_MANY:
        "That code isn't right. You have {{attempts}} more tries before you'll need a new code.",
    REPORTER_EMAIL_CONFIRM_ATTEMPTS_EXHAUSTED:
        'That was the last try for this code. Send a new code to try again, or remove the address and continue without it.',
    REPORTER_EMAIL_CONFIRM_ATTEMPTS_EXHAUSTED_MANDATORY:
        'That was the last try for this code. Send a new code to try again.',
    REPORTER_EMAIL_CONFIRM_EXPIRED:
        'That code has expired. Send a new one to try again, or remove the address and continue without it.',
    REPORTER_EMAIL_CONFIRM_EXPIRED_MANDATORY:
        'That code has expired. Send a new one to try again.',
    REPORTER_EMAIL_CONFIRM_NO_TRIES_LEFT:
        "That code can't be used any more. Send a new one to try again, or remove the address and continue without it.",
    REPORTER_EMAIL_CONFIRM_NO_TRIES_LEFT_MANDATORY:
        "That code can't be used any more. Send a new one to try again.",
    REPORTER_EMAIL_CONFIRM_RATE_LIMITED:
        'A code was sent recently. You can ask for another in {{seconds}}s.',
    REPORTER_EMAIL_CONFIRM_OTHER_CHANNELS:
        "If you can't receive the code, you can still submit a report through one of the organisation's other reporting channels.",
    REPORTER_EMAIL_CONFIRM_BLOCKING_PROCEED:
        'To continue, confirm this address — or remove it and carry on without one.',
    REPORTER_EMAIL_CONFIRM_BLOCKING_PROCEED_MANDATORY:
        'Before you continue, confirm this address.',
    REPORTER_UPDATES_EMAIL_UNCONFIRMED_SUBMIT:
        "This address isn't confirmed, so it won't be used. You won't get email updates - you can still check your report with your case ID and PIN.",
    REPORT_SUBMITTED_UPDATES_CONFIRMED:
        'Updates about this report will go to {{address}}.',
    REPORT_SUBMITTED_UPDATES_NONE:
        "You didn't add a confirmed email, so check back here with your case ID and PIN.",
    REPORTER_DISCLOSURE_SUMMARY_TITLE: 'What you are sharing',
    REPORTER_DISCLOSURE_SUMMARY_SHARED: '{{organisation}} will see:',
    REPORTER_DISCLOSURE_SUMMARY_ANONYMOUS:
        'Nothing that identifies you. You have not given your name or an email address, so {{organisation}} sees only your report.',
    REPORTER_DISCLOSURE_SUMMARY_NAME: 'Your name: {{name}}',
    REPORTER_DISCLOSURE_SUMMARY_EMAIL: 'Your email address: {{email}}',
    REPORTER_DISCLOSURE_SUMMARY_EMAIL_UNCONFIRMED:
        "This address is not confirmed yet, so it will not be used. Go back to confirm it, or leave it - either way you'll still get your report reference.",
    REPORTER_DISCLOSURE_SUMMARY_REPORT:
        'Your report, including everything you wrote and any files you attached.',
    REPORTER_DISCLOSURE_SUMMARY_PRIVATE:
        'The email address for updates you add before submitting stays private. {{organisation}} never sees it.',
    REPORTER_EMAIL_CONFIRM_UNAVAILABLE:
        "We couldn't check that address just now. Try again in a moment, or remove the address and continue without it.",
    REPORTER_EMAIL_CONFIRM_UNAVAILABLE_MANDATORY:
        "We couldn't check that address just now. Try again in a moment.",
    SPEAK_UP: 'Speak up',
    WAITING: 'Waiting',
    NO_ACTIVE_REPORTS_INFO:
        'You do not have a report yet. Do you wish share a concern with your company?',
    MULTI_FACTOR_AUTH: 'Multi-factor authentication',
    MFA_ADDITIONAL_VERIFICATION: 'MFA: Additional security verification',
    MFA_ADDITIONAL_VERIFICATION_TEXT:
        'In the event that you lose your MFA app or devices, you can have the system send you recovery instructions to your secondary email address. We only use this email address for recovery purposes.',
    SECONDARY_EMAIL_ADDRESS: 'Secondary email address',
    ENTER_NEW_SECONDARY_EMAIL: 'Enter new secondary email',
    SECONDARY_EMAIL_HAS_BEEN_SAVED:
        'Your secondary email address has been saved.',
    COPY_TO_CLIPBOARD: 'The secret key has been copied to your clipboard.',
    INVALID_CODE: 'The code is not valid. Please enter a valid one.',
    LOGIN_AGAIN_TO_SETUP_MFA:
        'Please log in again to your company portal in order to set up multi-factor authentication for your account.',
    SUCCESSFULL_MFA_RESET: 'MFA reset has been successfull',
    BACK_TO_WELCOME_PAGE: 'go back to welcome page',
    EMAIL_SENT_TO_RECOVERY_EMAIL:
        'Email has been sent to your recovery email address.',
    CHECK_INBOX_TO_RESET_MFA:
        'Please check your inbox and follow the instructions on the email to reset Multi-Factor Authentication.',
    NOT_RECEIVE_MFA_RESET_EMAIL: 'Did you not receive an email?',
    CHECK_JUNK_EMAIL_FOLDER: 'Check the junk mail folder or try again.',
    BACK: 'Back',
    NEW_CONVERSATION_GO_BACK_TITLE: 'Are you sure?',
    NEW_CONVERSATION_GO_BACK_DESCRIPTION:
        'Are you sure you want to go back to the previous part? You will lose all your changes on this screen.',
    SESSION_EXPIRED_TITLE: 'Authentication session expired',
    SESSION_EXPIRED_DESC:
        'Your authentication session has expired. Please try to log in again.',
    SESSION_EXPIRED_BUTTON: 'go back to welcome page',
    CHAT_MAX_CHARS: 'Text should not exceed 800 characters',
    MFA_RESET_MESSAGE: 'The email with the instructions has been sent.',
    MFA_INVALID_SECONDARY_EMAIL:
        'The given email address is the same as a primary one.',
    GO_TO_HOME_PAGE: 'go to home page',
    SUCCESSFULL_MFA_SETUP_TITLE: 'MFA setup has been successfull',
    SUCCESSFUL_MFA_SETUP_TEXT:
        'Please log in again to the Speeki mobile app using multi-factor authentication.',
    SUCCESSFUL_MFA_SETUP_CONFIRM: 'MFA has been set up for your account',
    SET_UP_LATER: 'I want to set up it later',
    CHECK_DETAILS: 'Check details',
    CREATE_ACCOUNT: 'create account',
    RECEIVE_UPDATES:
        'to receive updates and easily check the progress of all of your reports, or',
    CONTINUE_AS_GUEST: 'continue as a guest',
    CHECK_CASE_STATUS: 'Check incident status',
    NEW_LOGIN_DESCRIPTION:
        'If you want to stay up-to-date on your records and track your activities, please log in.',
    NEW_LOGIN_EMAIL_PLACEHOLDER: 'Enter your email address',
    NEW_LOGIN_INVALID_EMAIL:
        'Invalid email address. The correct format is: name@example.com',
    NEW_TO_SPEEKI: 'New to the Speeki platform?',
    CREATE_SPEEKI_ACCOUNT: 'Create an account',
    PROCEED_TO_THE_NEXT_STEP: 'Proceed to the next step',
    CREATE_AN_ACCOUNT: 'create an account',
    MAKE_REPORT: 'Make a report',
    MAKE_DECLARATION: 'Make a declaration',
    PARTICIPATE_IN_SURVEY: 'Participate in a pulse survey',
    GET_STARTED: 'get started',
    FIND_MORE_ABOUT_US: 'Find out more about us',
    MESSAGING_ACTION_TITLE: 'Report an incident',
    MESSAGING_ACTION_SUBTITLE:
        'Tell us what you have witnessed or any concerns or feedback you have. With our compliance assistant, reporting is easy, quick, safe and can be anonymous if you wish.',
    MESSAGING_ACTION_SUBTITLE_NOT_LOGGED_IN:
        'Click on START NEW REPORT to begin reporting an incident. Select SEE MY INCIDENTS to review previously submitted reports and to chat with a case manager.',
    DISCLOSURES_ACTION_TITLE: 'Fill up form',
    DISCLOSURES_ACTION_SUBTITLE:
        'Submit information, declare and disclose details, review past responses, monitor approval requests, and chat directly for any follow-ups',
    SURVEYS_ACTION_SUBTITLE:
        'Provide feedback, take part in surveys, complete assessments, receive updates',
    WHAT_CAN_WE_DO_FOR_YOU:
        'Would you like to create a report or check your incident status?',
    HOW_CAN_WE_HELP_YOU_TODAY: 'How can we help you today?',
    SEE_MY_CASES: 'See my incidents',
    START_NEW_REPORT: 'start new report',
    SEE_MY_FORMS: 'see my forms',
    SUBMIT_NEW_FORM: 'submit new form',
    SEE_ACTIVE_SURVEYS: 'see active pulses',
    READ_COMPANY_MESSAGE: 'Read company message',
    LEARN_COMPANY_POLICIES: 'learn about company policies',
    WELCOME_TO: 'Welcome to',
    SOLUTION_TO_MANAGE: 'solution to manage its ESG programme',
    DASHBOARD_SUBTITLE: 'For more information, you can see some of the',
    BELOW: 'below',
    MESSAGING_SUBTEXT:
        'Easy, quick and safe reporting service. Would you like to start?',
    FORMS_AVAILABLE: 'forms available',
    FORMS_SUBMITTED: 'forms submitted',
    SURVEYS_WAITING: 'pulses waiting',
    AVAILABLE: 'available',
    SUBMITTED: 'submitted',
    IM_NICOLE: 'Hi, I’m Nicole!',
    WELCOME_TO_SPEEKI_PLATFORM:
        'Welcome to the Speeki Platform. I can help you navigate through to the right place to engage with Speeki.',
    YOU_ARE_HERE_BECAUSE: 'You are here because',
    YOU_ARE: 'you are',
    WELCOME_TEXT_1: 'an employee of a company that has subscribed to Speeki',
    WELCOME_TEXT_2:
        'someone that wants to report an issue or otherwise engage with a company that uses Speeki.',
    WELCOME_TEXT_3:
        'So, to continue, start typing the name of the company. I can then direct you to the right place within Speeki.',
    ENTER_ENTITY_TITLE: 'Enter the entity name',
    ENTER_ENTITY: 'Enter entity name',
    ENTITY_NAME: 'Entity name',
    WELCOME_TOOLTIP_TEXT:
        "If you are an employee of a company that has subscribed to Speeki, enter the company name here. If you want to report an issue or otherwise engage with an entity that uses Speeki, enter that entity's name here.",
    WELCOME_CARD_DESCRIPTION:
        'Please enter the entity name to continue using our app.',
    WELCOME_TITLE: 'Welcome',
    SIGN_IN_TO_RETRIEVE: 'I will sign in to retrieve my records.',
    DO_NOT_HAVE_ACCOUNT: 'I don’t have any account',
    RETRIEVE_MY_REPORTS:
        'I will retrieve my report by providing Report ID and PIN.',
    TO_SEE_YOUR_CASES:
        'To see your incidents you need to be logged in. If you want to check the one single incidents status click on ‘check incident status’ and remain in a guest mode.',
    TO_FOLLOW_YOUR_CASE: 'To follow your incident progress in future, please',
    START_NEW_REPORT_TITLE: 'Start new report',
    LOGIN_DISCLOSURE_TITLE: 'Collect information',
    LOGIN_DISCLOSURE_BOX_TEXT:
        "To fill out Collect forms, you must be logged in. If you don't have an account, please create one.",
    LOGIN_SURVEYS_TITLE: 'See active pulses',
    GUEST_LOGIN: 'Log in with existing account',
    IF: 'if',
    GUEST_REGISTER_LIST_TEXT_1: 'You plan to use this app more than once.',
    GUEST_REGISTER_LIST_TEXT_2:
        'You want a record of your previous activity in the platform.',
    GUEST_REGISTER_DESCRIPTION:
        'Please select your relationship to the entity and the country you are in so Speeki can display the relevant content.',
    START_TO: 'Start to...',
    DECLARE_OR_DISCLOSE: 'Collect info',
    TELL_WHAT_YOU_WITNESSED:
        'Tell us what you have witnessed or any concerns or feedback you have.',
    PARTICIPATE_AND_LET_US_KNOW: 'Participate and let us know what you think!',
    SOMETHING_TO_DECLARE: 'Do you have something to declare to the company?',
    REGISTER_EMAIL_PLACEHOLDER: 'Enter email address',
    CREATE_ACCOUNT_TITLE: 'Create an account',
    BACK_TO_ENTITY_SELECTION: 'Back to entity selection',
    GUEST: 'GUEST',
    REPORT_INFO_NOT_PROVIDED:
        "Before clicking 'next', please answer this question.",
    INSTALL_SPEEKI_APP: 'Do you want to install the Speeki mobile app?',
    INSTALL_SPEEKI_APP_DESCRIPTION:
        "Click on 'INSTALL' to use our app and access the full range of services available to you.",
    INSTALL: 'install',
    NOT_SURE_ABOUT_ENTITY_NAME: 'Not sure about the entity name?',
    CONTACT_SPEEKI_TEAM: 'Contact Speeki team.',
    CONTACT_SUPPORT_TITLE: 'Contact Speeki support',
    CONTACT_SUPPORT_NOTE:
        "This form is for help using the portal. Don't use it to make a report. Speeki support can't act on reports. Use your company's reporting option instead.",
    CONTACT_SUPPORT_NAME_LABEL: 'Name (optional)',
    CONTACT_SUPPORT_SEND: 'Send',
    CONTACT_SUPPORT_SENT: 'Message sent. Support will reply by email.',
    CONTACT_SUPPORT_TOO_MANY:
        "You've sent several messages recently. Try again later.",
    CONTACT_SUPPORT_FAILED:
        "Couldn't send your message. Try again, or email {{email}}.",
    PIN_EQUAL_TO_6: 'PIN code must be equal to 6 characters',
    PIN_NUMBERS_ONLY: 'Report PIN should contain numbers only',
    BUSINESS_UNIT: 'Business unit',
    SELECT_BUSINESS_UNIT: 'Select your business unit',
    SELECT_BUSINESS_UNIT_HEADER: 'Select business unit',
    SELECT_SUBSIDIARY_SITES_DESCRIPTION:
        'Start by choosing your entity. Your report may be submitted to the headquarters or to a local entity for incident, depending on the regulations.',
    SELECT_BUSINESS_UNIT_OPTIONS:
        'Select where to report to: the local office or the headquarters?',
    SELECT_BUSINESS_UNIT_OPTION_1: 'Local office',
    SELECT_BUSINESS_UNIT_OPTION_2: 'Headquarters',
    ADDITIONAL_DETAILS_HEADER: 'The options you selected are listed below.',
    ADDITIONAL_DETAILS_MANAGERS: 'Excluded incident manager',
    ADDITIONAL_DETAILS_INVESTIGATION: 'Who should investigate your incident?',
    OPTIONAL: 'Optional',
    FALLBACK_USER_INFO_PART_1: 'The company has designated',
    FALLBACK_USER_INFO_PART_2: 'to review your report based on your exclusion.',
    HOME: 'Home',
    SEE_REPORT_DETAILS: 'See report details',
    REPORT_DETAILS: 'Report details',
    STEP: 'Step',
    OF: 'of',
    PASSWORD_VALIDATION_LOWERCASE: 'At least 1 lower case',
    PASSWORD_VALIDATION_UPPERCASE: 'At least 1 upper case',
    PASSWORD_VALIDATION_NUMBER: 'At least 1 number',
    PASSWORD_VALIDATION_SYMBOL: 'At least 1 special character',
    PASSWORD_VALIDATION_LENGTH: 'Contain between 8 and 64 characters',
    CLOSE: 'Close',
    PASSWORD_CHANGED: 'Your password has been successfully changed',
    INCIDENT_TYPES: 'Incident types',
    INCIDENT_TYPES_LABEL: 'Not sure what to select?',
    INCIDENT_TYPES_DESCRIPTION:
        'Here you can find in-depth explanations of different incident types and when to select them',
    WRONG_CURRENT_PASSWORD:
        'The given password is different from the current one',
    SURVEY_QUIZ_1: 'You obtained',
    SURVEY_QUIZ_2: 'on the pulse by scoring',
    SURVEY_QUIZ_3: 'points of the total',
    VERSION: 'Version',
    SUBSIDIARY: 'Entity',
    SELECT_SUBSIDIARY: 'Select your entity',
    SELECT_SUBSIDIARY_PLACEHOLDER: 'Select entity',
    ERROR_TENANT_NOT_EXIST: 'Tenant for given slug does not exists',
    CHANGE_SUBSIDIARY_SITE: 'Switch entity',
    SWITCH: 'Switch',
    CHANGE_SUBSIDIARY_SITE_DESCRIPTION:
        'If you want to switch entity, select the one below.',
    DISCLOSURE_MICROSERVICE_BOX_TEXT: 'To use the Collect, please',
    SURVEY_MICROSERVICE_BOX_TEXT: 'To use the Pulses, please',
    DISCLOSURE_SURVEY_MICROSERVICE_BOX_TEXT:
        'To use the Pulse or Collect, please',
    TO_HEADQUARTERS: 'to Headquarters.',
    REPLACE_COMPANY_TITLE: 'Switching the company',
    REPLACE_COMPANY_TEXT_1: 'You are trying to access to a different company',
    REPLACE_COMPANY_TEXT_2: 'than you are currently logged in',
    REPLACE_COMPANY_TEXT_3:
        'Are you sure you want to switch companies and continue?',
    ROLE: 'Role',
    ROLE_PLACEHOLDER: 'Enter your role',
    ORGANISATION_NAME_LABEL: 'Organisation name',
    ORGANISATION_EMAIL_LABEL: 'Organisation email',
    ORGANISATION_NAME_PLACEHOLDER: 'Enter your organisation name',
    ORGANISATION_EMAIL_PLACEHOLDER: 'Enter your organisation email',
    ORGANISATION_EMAIL_TOOLTIP:
        'This email is different from your user email and can be used as an alternative contact for anything related to the submitted form',
    PERSONAL_INFORMATION: 'Provide additional Information',
    PERSONAL_INFORMATION_TEXT_INDIVIDUAL:
        'We need this information to verify your identity and facilitate any necessary follow-ups regarding your submission. Please note that the details you provide will be included with your submission and used only for this purpose. They will not be shared or used for other services.',
    PERSONAL_INFORMATION_TEXT_ORGANISATION:
        'We require both your organisation’s details and your own information as the respondent to verify identity and facilitate any necessary follow-ups regarding your report. The information provided will be included with your submission and used solely for this purpose. They will not be shared or used for other services.',
};

export const defaultUserRelationship = USER_RELATIONSHIP;

export const defaultCountries = COUNTRY_CODE_ORDERED;

export const defaultCaseStatuses = caseStatusesIterable.reduce(
    (prevValue, currentValue) => ({
        ...prevValue,
        [currentValue.key]: currentValue.key,
    }),
    {},
);
